import type { PageLoadingProps } from './const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import LogoLoading from '../LogoLoading';
import './index.less';

function PageLoading(props: PageLoadingProps, ref: React.Ref<HTMLDivElement>) {
  const { className, style } = props;

  return <LogoLoading ref={ref} className={cn('wg-page-loading', className)} style={style} />;
}

const PageLoadingComponent = forwardRef<HTMLDivElement, PageLoadingProps>(PageLoading);

PageLoadingComponent.displayName = 'PageLoading';

export default PageLoadingComponent;

export type { PageLoadingProps };
